import { createApp } from 'vue'
import { createPinia } from 'pinia'

import App from './App.vue'

import ElementPlus from 'element-plus'
import zhCn from 'element-plus/es/locale/lang/zh-cn.mjs'
import 'element-plus/dist/index.css'
import 'element-plus/theme-chalk/dark/css-vars.css'
import './utils/app-back'
import './assets/styles/animista.css'
import * as Sentry from '@sentry/vue'

const app = createApp(App)

app.use(createPinia())
app.use(ElementPlus, {
  locale: zhCn,
})

Sentry.init({
  app,
  dsn: 'https://f7bf6a2e15f9539eed101f4d8c85252a@o4510667686150144.ingest.us.sentry.io/4510667695980544',
  sendDefaultPii: true,
})

app.mount('#app')
